module.exports = __webpack_public_path__ + "static/felipe_fs-7f9c231a3720d184ded5463e39f1612b.png";